export default __webpack_public_path__ + "static/media/menu_materials_icon.fa3b0b69.svg";